var Curriculog = Curriculog || {};


/**
 * A dialog with a Show Me button that scrolls the page to an element.
 * If `elements` is not given or is falsy, the "Show Me" button will not show.
 *
 * Basic usage:
 *
 * new Curriculog.ShowMeErrorDialog({
 *     title: 'Oh noes!',
 *     message: 'There seems to have been an error',
 *     elements: $('.error')
 * })
 *
 *
 * Alternatively, elements can be a function that returns zero or more elements
 *
 * new Curriculog.ShowMeErrorDialog({
 *     elements: function(){
 *         open_some_tab();
 *         return $('.error-in-tab');
 *     },
 * })
 *
 */
Curriculog.ShowMeErrorDialog = (function ($, _, Backbone, ShowMeErrorDialog) {
    ShowMeErrorDialog = Curriculog.WarningDialog.extend({
        buttons: function() {
            var buttons = {Ok: 'close'};
            if (this.elements.length) {
                _.extend(buttons, {'Show Me': 'showMe'});
            }
            return buttons;
        },

        showMe: function() {
            this.close();
            var showEle = _.result(this, 'elements');
            if (!showEle) {
                return;
            }
            // scroll the page to the first required error
            $('html, body').animate({
                scrollTop: $(showEle).offset().top - 200
            }, 'fast').promise().done(function(){
                $(showEle).effect('highlight');
            });
        }
    });
    return ShowMeErrorDialog;
})($, _, Backbone, Curriculog.ShowMeErrorDialog || {});
